import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-clear-filter-button',
  template: `
    <button type="button" class="button-secondary-warning" (click)="clearClicked.emit($event)">
      {{ 'action.clearAll' | transloco }}
    </button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClearFilterButtonComponent {
  @Output() clearClicked = new EventEmitter<MouseEvent>();
}
